import {LOCALE_ID, NgModule, Type} from '@angular/core';
// Imports third-party shared modules (angular, angular materials, covalent,..)
import {SharedModule} from './shared/shared.module';
import {InitModule} from "./init.module";
// App Components
import {AppIndexComponent} from './components/index/app.index.component';
import {AppUploadpaketeMainComponent} from './components/index/app.uploadpakete.main';
import {AppMakpakkraftMainComponent} from './components/index/app.makpakkraft.main';
import {AppPageNotFoundComponent} from './components/pagenotfound/app.pagenotfound.component';
// App Services
import {AdminService} from './components/admin/services/admin.service';
import {PaketService} from './components/index/service/paket.service';
import {KraftpaketService} from './components/index/service/kraftpaket.service';
import {MaklerPaketStatusService} from './components/index/service/detail.service';
// App Events
import {IEvent} from './config/interfaces';
import {SidebarNavEvent} from './config/events/sidebarNav.event';
// App Global service
import {UserData} from './config/globals/userData.global';
import {CsvExport} from './config/globals/csvExport.global';
// App Routing
import {AppRoutingModule} from './app-routing.module';
// App Interceptor
import {CovalentHttpModule, IHttpInterceptor} from '@covalent/http-deprec';
import {HttpLoadingInterceptor} from './config/interceptors/loading.interceptor';
import {HttpErrorHandlingInterceptor} from './config/interceptors/errorHandling.interceptor';
import {CsvUploadService} from './components/index/service/csv-upload.service';
import {PackageTableComponent} from './components/index/tables/package-table/package-table.component';
import {SideScrollingComponent} from './components/index/tables/side-scrolling/side-scrolling.component';
import {ProcessTableComponent} from './components/index/tables/process-table/process-table.component';
import {KraftHeaderTemplate} from './components/index/tables/template-header/kraft.header.template';
import {GeschaeftsvorgangTableComponent} from './components/index/app.geschaeftsvorgangs.component';
import {CsvDownloadService} from './components/index/service/csv-download.service';
import {AppMaklerpaketKraft} from './components/index/kraft/app.maklerpaket.kraft';
import {AppPaketsucheKraft} from './components/index/kraft/app.paketsuche.kraft';
import {BenutzerService} from './components/index/service/benutzer.service';
import {CsvImport} from './config/globals/csvImport';
import {AppAdministrationKraft} from "./components/index/kraft/app.administration.kraft";
import {TableModule} from "primeng/table";
import {ButtonModule, CalendarModule, DropdownModule} from "primeng/primeng";
import {MultiSelectModule} from 'primeng/multiselect';
import {DialogModule} from 'primeng/dialog';
import {AppDatatableKraft} from './components/index/kraft/app.datatable.kraft';
import {UmlautPipe} from './config/pipes/UmlautPipe';
import {AppMaklerpaketUploadKraft} from './components/index/kraft/app.maklerpaket-upload.kraft';
import {AppIndexKraft} from './components/index/kraft/app.index.kraft';
import {Globals} from "./components/index/globals";

import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {ProgressBarModule} from 'angular-progress-bar';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import { MatDialogModule, MatProgressSpinnerModule } from '@angular/material';
import {AppMaklerpaketKraftHistList} from "./components/index/kraft/app.maklerpaket.kraft.hist.list";
import {HistlistService} from "./components/index/service/histlist.service";
import {MpHistoryService} from "./components/index/service/mp.history.service";
import {MakpakhttpInterceptor} from "./config/interceptors/makpakhttp.interceptor";
import { AuthComponent } from './components/auth/auth.component';
import {AppMassenberechnungUploadKraft} from './components/index/kraft/massenberechnung/app.massenberechnung-upload.kraft';
import {AppMassenberechnungKraft} from './components/index/kraft/massenberechnung/app.massenberechnung.kraft';
import { AppMeinkonto, DialogOverview } from './components/index/kraft/meinkonto/app.meinkonto';
import { SessionExpiryDialogComponent } from './services/session-expiry-dialog.component';
import { NumberPipe } from './config/pipes/NumberPipe';
import { NxFormfieldModule } from '@allianz/ngx-ndbx/formfield';
import { NxIconModule } from '@allianz/ngx-ndbx/icon';
import { NxButtonModule, NxCheckboxModule, NxDropdownModule, NxTabsModule } from '@allianz/ngx-ndbx';
import { NxTableModule } from '@allianz/ngx-ndbx/table';
import { NxHeaderModule } from '@allianz/ngx-ndbx/header';
import { NxInputModule } from '@allianz/ngx-ndbx/input';


registerLocaleData(localeDe, 'de');

const eventsProviders: Type<IEvent>[] = [
  SidebarNavEvent,
];

const globalsProviders: Type<any>[] = [
  UserData, CsvExport,
];

const httpInterceptorProviders: Type<IHttpInterceptor>[] = [
  HttpLoadingInterceptor, HttpErrorHandlingInterceptor,
];

@NgModule({
  imports: [
    InitModule,
    AppRoutingModule,
    SharedModule,
    CovalentHttpModule.forRoot({
       interceptors: [
         {interceptor: HttpLoadingInterceptor, paths: ['**']},
         {interceptor: HttpErrorHandlingInterceptor, paths: ['**']},
       ],
    }),
    TableModule,
    DropdownModule,
    DialogModule,
    ButtonModule,
    MultiSelectModule,
    ProgressBarModule,
    BrowserModule,
    NxFormfieldModule,
    NxIconModule,
    NxCheckboxModule,
    NxTableModule,
    NxInputModule ,
    NxButtonModule,
    NxHeaderModule,
    NxTabsModule,
    NxDropdownModule,
    BrowserAnimationsModule,
    CalendarModule,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  declarations: [
    AppIndexKraft,
    DialogOverview,
    AppIndexComponent,
    AppUploadpaketeMainComponent,
    AppMakpakkraftMainComponent,
    AppPageNotFoundComponent,
    PackageTableComponent,
    SideScrollingComponent,
    ProcessTableComponent,
    KraftHeaderTemplate,
    GeschaeftsvorgangTableComponent,
    AppMassenberechnungKraft,
    AppMaklerpaketKraft,
    AppPaketsucheKraft,
    AppDatatableKraft,
    AppMeinkonto,
    AppAdministrationKraft,
    AppMaklerpaketUploadKraft,
  AppMaklerpaketKraftHistList,
  AuthComponent,
    AppMassenberechnungUploadKraft,
    UmlautPipe,
    NumberPipe,
    SessionExpiryDialogComponent
  ],
  entryComponents:[DialogOverview, SessionExpiryDialogComponent],
  providers: [
  // Combined CIAM + MakPak interceptor handles auth header, XSRF and redirects
  { provide: HTTP_INTERCEPTORS, useClass: MakpakhttpInterceptor, multi: true },
    {provide: LOCALE_ID, useValue: 'de-DE'},
    httpInterceptorProviders,
    eventsProviders,
    globalsProviders,
    PaketService,
    KraftpaketService,
    HistlistService,
    MpHistoryService,
    MaklerPaketStatusService,
    AdminService,
    CsvUploadService,
    AppMeinkonto,
    CsvImport,
    CsvDownloadService,
    BenutzerService,
    Globals
  ],

  bootstrap: [AppIndexComponent],
})
export class AppModule {
}
